import { EntityTypeRepository, EntityInstanceRepository } from "../domain/Entities"
import { EntityInstanceEditorScreenData } from "../domain/EntityInstanceEditorScreenData"

export class EntityInstanceEditorComponent {
    
    entity_type_repo:EntityTypeRepository
    entity_instance_repo:EntityInstanceRepository
    screen_data: EntityInstanceEditorScreenData
    company_id:number
    
    constructor(entity_type_repo:EntityTypeRepository,screen_data:EntityInstanceEditorScreenData, entity_instance_repo:EntityInstanceRepository, company_id:number){ 
        this.entity_type_repo = entity_type_repo
        this.screen_data = screen_data
        this.entity_instance_repo = entity_instance_repo
        this.company_id = company_id
    }

    async mountInstanceEditor(entity_instance_id:string, entity_type_id:string) {
        // console.log(entity_instance_id, entity_type_id)
        let entity_type = null
        let entity_instance = null
        if (entity_instance_id) {
            entity_instance = await this.entity_instance_repo.get_instance_by_id(entity_instance_id)
            entity_type = await this.entity_type_repo.get_type_by_id(entity_instance.entity_type_id,true)
        }
        else if (entity_type_id) {
            entity_type = await this.entity_type_repo.get_type_by_id(entity_type_id, true)
            entity_instance = this.entity_instance_repo.create_empty_entity_instance(this.company_id, entity_type)
        }
        else{
            console.log("No entity type or instance id, have to exit")
            return false // No entity type or instance id, have to exit
        }
        this.screen_data.entityType = entity_type
        this.screen_data.entityInstance = entity_instance
        return true
        

    }

    async saveEntityInstance() {
        this.screen_data.loading = true
        let entity_instance = this.screen_data.entityInstance
        console.log(entity_instance)
        let res = await this.entity_instance_repo.save(entity_instance)
        if (res && res['status'] == 'ok') {
            let inst = await this.entity_instance_repo.get_instance_by_id(res['instance_id'])
            this.screen_data.entityInstance = inst
            this.screen_data.success_message('Instancia guardada correctamente')
        }
        else {
            this.screen_data.error_message('Error al guardar la instancia')
        }
        this.screen_data.loading = false
    }

    async reloadInstance() {
        if (!this.screen_data.entityInstance || !this.screen_data.entityInstance.uuid) {
            return false
        }
        this.screen_data.loading = true
        try {
            let inst = await this.entity_instance_repo.get_instance_by_id(this.screen_data.entityInstance.uuid)
            this.screen_data.entityInstance = inst
            return true
        } catch (error) {
            this.screen_data.error_message('Error al recargar la instancia')
            return false
        } finally {
            this.screen_data.loading = false
        }
    }
}